import { ConstructionOutlined } from '@mui/icons-material';
import { Typography } from '@mui/material';
import { Container, Stack } from '@mui/system';
import { EmptyStateAvatar } from 'components/ui/empty-state-avatar';

export const MaintenanceModePage = ({ message }: { message: string }) => {
	return (
		<Container maxWidth="sm" sx={{ height: '100%' }}>
			<Stack
				justifyContent="center"
				alignItems="center"
				textAlign="center"
				spacing={2}
				height="100%">
				<EmptyStateAvatar
					icon={<ConstructionOutlined />}
					avatarProps={{ bgcolor: 'primary.50' }}
					iconProps={{ color: 'primary.500' }}
				/>
				<Typography variant="h1">Maintenance Mode</Typography>
				<Typography variant="body1">{message}</Typography>
			</Stack>
		</Container>
	);
};
